import React, { Component } from "react";
import {
  Table,
  Modal,
  Input,
  Progress,
  Select,
  message,
  Upload,
  Button,
  Icon,
  Form,
  notification,
  Cascader,
} from "antd";
import oss from "ali-oss";
import {
  inspiration_imgListUpload
} from "../../../../api/inspiration";
import "./index.less";
import AliUploader from "../../../../component/AliUploader/linggan_aliupload";

Form.create();
message.config({
  maxCount: 1,
});
class Index extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      uploadProgress: 0,
      token: {
        host: "https://image.znzgo.com/",
        ALI_HOST: "https://qingtu-image-originals.oss-cn-shanghai.aliyuncs.com",
        access_key_id: "LTAI5t8ubGymdJDnqyAe2EM2", // oss的key_id
        access_key_secret: "zfkvIN3eft7FrYJqfCRDURjGxhSHcF", // oss的secret
        OSS_ENDPOINT: "oss-cn-shanghai.aliyuncs.com", // 自己oss服务器的配置信息
        OSS_BUCKET: "qingtu-image-originals", // 自己oss服务器的配置信息
        OSS_REGION: "oss-cn-shanghai",
      },
      OSSData: {},
      fileList: [], //上传的文件夹中的文件
      dirName: '',  //上传的文件夹名称
      inputValue: '', // 选择框内值
      collName: '', // 图集名称
      collDescription: '', // 图集描述
      imgList: [],
      newImgList: [],
      canUpload: false,
    };
  }

  componentDidMount() {
    const OSSData = this.uploaderInit();
    this.setState({
      OSSData,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.uploadAddModal === true && this.props.uploadAddModal === false) {
      this.onResetUpload();
    }
  }

  client() {
    const {
      token: { access_key_id, access_key_secret },
    } = this.state;

    // ali-oss v6.x版本的写法
    return new oss({
      accessKeyId: access_key_id,
      accessKeySecret: access_key_secret,
      endpoint: "oss-cn-shanghai.aliyuncs.com",
      bucket: "qingtu-image-originals",
    });
  }

  inputFileUpload = async (e) => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    const file = files[0];
    const name = file.name;

    let nameArr = name.split(".");
    let _fileType = nameArr[nameArr.length - 1];
    if (_fileType != "jpg" && _fileType != "png" && _fileType != "jpeg") {
      return message.warn("文件格式错误");
    }
    const url = `/${new Date().getTime()}.${_fileType}`;
    console.log(8989, url);
    console.log(9090, file);
    message.loading("上传中", 0);
    try {
      let result = await this.client().multipartUpload(url, file, {});
      if (result.res.status == 200) {
        message.destroy();
        message.info(`上传成功`);
      } else {
        message.destroy();
        message.info(`上传失败`);
      }
    } catch (e) {
      message.destroy();
      console.log(e.toString());
    }
  };

  handleChange = (val) => {
    console.log(val);
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log("Received values of form: ", values);
      }
    });
  };

  customRequest = (e) => {
    message.loading('读取中')
    const dirName = `${e.file.webkitRelativePath.split("/")[0]}`;
    this.setState((preState) => ({
      fileList: [...preState.fileList, e],
      dirName
    }));
  };

  onResetUpload = () => {
    this.setState((preState) => ({
      fileList: [],
      dirName: '',
      uploadProgress: 0
    }));
  }

  onRemove = (file) => {
    console.log("file", file);
    const { fileList } = this.state;
    const i = fileList.findIndex((v) => v.uid === file.uid);
    fileList.splice(i, 1);
    this.setState({
      fileList: [...fileList],
    });
  };

  simulateFetch = (v, i, newImgList) => {
    return new Promise((resolve, reject) => {
      const { OSSData } = this.state;
      let data = new FormData();
      const filename = this.calculate_object_name(v.file.name);
      const imgList = filename.split("/")[1]
      newImgList.push(imgList)
      data.set("name", filename);
      data.set("key", filename);
      data.set("OSSAccessKeyId", OSSData.OSSAccessKeyId);
      data.set("policy", OSSData.policy);
      data.set("signature", OSSData.signature);
      data.set("success_action_status", OSSData.success_action_status);
      data.set("file", v.file, filename);
      var xhr = new XMLHttpRequest();
      xhr.open("POST", OSSData.host);
      xhr.send(data);
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 2) {
          // message.loading("上传中");
        }
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(1);
          } else {
            message.error("上传失败");
          }
        }
      };
    });
  }

  customForeach = async (arr, callback) => {
    const length = arr.length;
    const O = Object(arr);
    let k = 0;
    while (k < length) {
      if (k in O) {
        const kValue = O[k];
        await callback(kValue, k, O);
      }
      k++;
    }
  };

  imgUploader = async () => {
    const { fileList } = this.state;
    console.debug('fileList',fileList)
    if (fileList.length <= 0) {
        message.error('请先选择文件夹');
        return;
    }
    let newImgList = []
    await this.customForeach(fileList, async (v, i) => {
      const res = await this.simulateFetch(v, i, newImgList)
      console.debug('res',res)
      if (res === 1) {
        await this.setState({ uploadProgress: parseInt((i + 1) * 100 / fileList.length) });
        notification.success({
          message: '成功',
          description: '文件夹上传完成！',
          duration: 2,
        });
        await this.setState({
          newImgList,
          canUpload: true,
        });
      }
    });
  };

  uploadSuccess = () => {
    const { collDescription, dirName, newImgList, canUpload, collName } = this.state;
    if (!canUpload) {
      message.error("请先点击确定上传")
      return
    } else {
      let params = {
        collDescription,
        collName,
        folderName: dirName.split(",")[1],
        imgList: newImgList,
      }
      inspiration_imgListUpload(params).then(
        (res) => {
          if (res && res.error && res.error.code === 0) {
            message.success('上传成功')
            this.setState({
              canUpload: false,
              newImgList: []
            });
          } else {
            message.error("请重新上传")
          }
        }
      )
    }
  }

  calculate_object_name = (filename) => {
    let suffix = this.get_suffix(filename);
    let g_object_name = this.state.dirName.split(",")[1] + '/' + this.get_name(filename) + this.random_string(10) + suffix;
    this.setState({ currentUploadImgName: g_object_name });
    return g_object_name;
  };

  get_name = (filename) => {
    let pos = filename.lastIndexOf(".");
    let prefix = "";
    if (pos != -1) {
      prefix = filename.substring(0, pos);
    }
    return prefix;
  }

  get_suffix = (filename) => {
    let pos = filename.lastIndexOf(".");
    let suffix = "";
    if (pos != -1) {
      suffix = filename.substring(pos);
    }
    return suffix;
  };

  random_string = (len) => {
    len = len || 32;
    let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    let maxPos = chars.length;
    let pwd = "";
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  };

  onOk = () => {
    this.imgUploader();
  };

  handleCollName = (e) => {
    const { setFieldsValue } = this.props.form;
    this.setState({ collName: e.target.value });
    setFieldsValue({
      collName: e.target.value
    });
  }

  handleCollDescription = (e) => {
    const { setFieldsValue } = this.props.form;
    this.setState({ collDescription: e.target.value });
    setFieldsValue({
      collDescription: e.target.value
    });
  }

  render() {
    let { token, dirName, uploadProgress, canUpload, collName, collDescription } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Modal
          visible={this.props.uploadAddModal}
          onCancel={() => {
            this.setState({ canUpload: false });
            this.props.onCancel();
          }}
          okText="确定"
          okButtonProps={!canUpload ? { disabled: true } : {}}
          cancelText="取消"
          onOk={this.uploadSuccess}
          destroyOnClose={true}
          maskClosable={false}
        >
          <div>
            <Form name="uploadImg">
              <Form.Item name="collName" label="图集名称">
                {getFieldDecorator(`collName`, {
                  rules: [{ required: true, message: "请输入图集名称" }],
                })(
                  <Input
                    placeholder="请输入图集名称"
                    allowClear={true}
                    style={{ width: "auto" }}
                    onChange={this.handleCollName}
                  />
                )}
              </Form.Item>
              <Form.Item name="collDescription" label="图集描述">
                {getFieldDecorator(`collDescription`, {
                })(
                    <Input
                        placeholder="请输入图集描述"
                        allowClear={true}
                        style={{ width: "auto" }}
                        onChange={this.handleCollDescription}
                    />
                )}
              </Form.Item>
              <Form.Item name="upLoadPic" label="选择文件夹上传">
                {getFieldDecorator(`upLoadPic`, {
                  rules: [{ required: true, message: "请上传文件夹" }],
                })(
                  <div>
                    <Upload
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      directory
                      customRequest={this.customRequest}
                      onRemove={this.onRemove}
                      showUploadList={false}
                    >
                      <Button>
                        <Icon type="upload" /> 选择文件夹
                      </Button>
                    </Upload>
                    <Button style={{ marginLeft: 30 }} onClick={this.onOk}>确定上传</Button>
                  </div>
                )}
              </Form.Item>
              {dirName
                ? <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <img className="upload-wenjianjia" src="https://znztv-image.oss-cn-shanghai.aliyuncs.com/manager/wenjianjia.png"></img>
                    <span style={{ marginLeft: 10 }}>{dirName}</span>
                  </div>
                  <img onClick={this.onResetUpload} className="upload-lajitong" src="https://znztv-image.oss-cn-shanghai.aliyuncs.com/manager/lajitong.png"></img>
                </div>
                : null}
              {uploadProgress
                ? <Progress
                  strokeColor={{
                    from: '#108ee9',
                    to: '#87d068',
                  }}
                  percent={uploadProgress}
                  status="active"
                />
                : null}
            </Form>
          </div>
        </Modal>
        <AliUploader
          uploaderInit={(uploaderInit) => (this.uploaderInit = uploaderInit)}
          token={token}
        />
      </div>
    );
  }
}

const form = Form.create({ name: "uploadImg" })(Index);
export default form;
